module.exports = __webpack_public_path__ + "img/DW365-007.b254c220.jpg";